import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import { TableWrapper } from 'modules/list/table';

export default class PaymentInfo extends PureComponent {
  render() {
    const { paymentInfo } = this.props;

    const tableColumns = [
      {
        columns: [
          {
            Header: 'TRN ID',
            accessor: 'invoice_id',
          },
          {
            Header: 'Payment Date',
            accessor: 'payment_date',
          },
          {
            Header: 'Amount',
            accessor: 'amount',
          },
          {
            Header: 'Tenure',
            accessor: 'duration',
          },
          {
            Header: 'Product Type',
            accessor: 'product_type',
          },
          {
            Header: 'Status',
            accessor: 'state',
          },
        ],
      },
    ];

    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={paymentInfo}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={5}
            columns={tableColumns}
            style={{ height: 230 }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}
